export default __webpack_public_path__ + "static/media/shower-rain-night.8465c2fc.svg";